import type { CSSProperties } from 'react'
import React from 'react'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Icon } from '@fourthwall/components'
import { DragIcon } from '@fourthwall/icons'

import type { Perk as PerkType } from '../../hooks/types'
import { usePerksContext } from '../../hooks/usePerksContext'
import * as S from './styled'

type Props = {
  perk: PerkType
}

export const Perk = ({ perk }: Props) => {
  const { editPerk } = usePerksContext()

  const { isDragging, setNodeRef, transform, attributes, listeners } = useSortable({
    id: perk.id,
  })

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    zIndex: isDragging ? 999 : undefined,
  }

  return (
    <S.Container ref={setNodeRef} style={style} onClick={() => editPerk(perk)}>
      <S.Title data-testid="Perks.title">{perk.title}</S.Title>
      <S.DragHandle {...listeners} {...attributes}>
        <Icon component={DragIcon} height={16} />
      </S.DragHandle>
    </S.Container>
  )
}
